import styled from "styled-components";

export const StyledHeader = styled.header`
    display: flex;
    width: 100%;
    justify-content: space-between;
    height: 100px;

    border-bottom: 1px solid var(--dark--green--50);

    h1{
        margin-left: 2rem;
    }
`

export const StyledMenuSection = styled.section`
    width: 100%;
    display: flex;
    justify-content: space-between;

    h1{
        margin-left: 2rem;
    }
`

export const StyledMenuIconsSection = styled.section`
    display: flex;
    margin-right: 2rem;
`